<div class="datasets-settings-container">
  <div class="tab-description">
    Datasets can be uploaded in CSV or Excel format. Once uploaded, you can configure display fields and value mappings
    for your data analysis.
  </div><br>

  <!-- Header + paging similar to outbox -->
  <div class="datasets-header">
    <div class="left-actions">
      <div class="litmus-feed-controls">
        <button class="request-btn" [disabled]="!isUserHasWriteAccess" (click)="openDatasetModal()">
          <span class="request-btn-label">Add New Dataset</span>
        </button>
        <div class="litmus-feed-controls">
          <div class="litmus-refresh-feeds" (click)="refreshData()">
            <img src="assets/images/refresh.svg" /> Refresh
          </div>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <div class="litmus-feed-filter" *ngIf="searchBoxVisible">
        <div class="litmus-feed-filter-input">
          <img class="search-icon" src="assets/images/magnify.svg">
          <input class="litmus-feed-input-field" placeholder="Search Datasets" type="text"
            (keyup)="onSearchInput($event)" [(ngModel)]="searchText" autocomplete="nope" />
          <!-- <button [class.hidden]="!isTextEntered" (click)="clearSearchBox()">
          <img class="clear-img" src="assets/images/close.svg">
        </button> -->
        </div>
      </div>
      <div class="pagination-container">
        <div class="pagination-controls">
          <button class="pagination-btn" [disabled]="!pagingButtons.isFirst || loading"
            (click)="paginateDatasets('first')" title="First page">
            <img src="assets/images/angle-double-left.svg" />
          </button>
          <button class="pagination-btn" [disabled]="!pagingButtons.isPrevious || loading"
            (click)="paginateDatasets('previous')" title="Previous page">
            <img src="assets/images/angle-left.svg" />
          </button>
          <div class="pagination-info">
            <span [class.disabled]="pagingDetails.total <= 0">{{pagingDetails.start}} - {{pagingDetails.end}} of
              {{pagingDetails.total}}</span>
          </div>
          <button class="pagination-btn" [disabled]="!pagingButtons.isNext || loading"
            (click)="paginateDatasets('next')" title="Next page">
            <img src="assets/images/angle-right.svg" />
          </button>
          <button class="pagination-btn" [disabled]="!pagingButtons.isLast || loading"
            (click)="paginateDatasets('last')" title="Last page">
            <img src="assets/images/angle-double-right.svg" />
          </button>
        </div>
        <div class="pagination-actions">
          <!-- <button class="download-btn" title="Download data" (click)="downloadData()">
          <img src="assets/images/download.svg" />
        </button> -->
        </div>
      </div>
    </div>

  </div>

  <!-- Table -->
  <div class="table-wrap">
    <table class="datasets-table">
      <thead>
        <tr>
          <th class="sortable-header" (click)="onSort('name')">
            <div class="header-content">
              <span>Dataset</span>
              <img [src]="getSortIcon('name')" class="sort-icon" [class.active]="sortColumn === 'name'" />
            </div>
          </th>
          <th class="sortable-header">
            <div class="header-content">
              <span>File Name</span>
            </div>
          </th>
          <th class="sortable-header" (click)="onSort('created_date')">
            <div class="header-content">
              <span>Upload Date</span>
              <img [src]="getSortIcon('created_date')" class="sort-icon"
                [class.active]="sortColumn === 'created_date'" />
            </div>
          </th>
          <th class="sortable-header">
            <div class="header-content">
              <span>Size</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of tableData; let i = index" [class.zebra]="i % 2 === 0">
          <td>
            <span class="dataset-name">{{ d.name }}</span>
          </td>
          <td>{{ d.file_name }}</td>
          <td>{{ d.created_date | date:'dd MMM yyyy hh:mm a' }}</td>
          <td class="text-right">{{ d.file_size }}</td>
        </tr>
        <tr *ngIf="tableData.length === 0">
          <td colspan="4" class="empty">No datasets</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Left Side Panel Modal for Create Dataset -->
<div class="group-side-panel" *ngIf="showDatasetModal">
  <div class="side-panel-overlay" (click)="dismissModal()"></div>
  <div class="side-panel-container">
    <div class="side-panel-header">
      <div class="header-label">{{ isEditing ? 'Edit Dataset' : 'Dataset' }}</div>
      <div class="header-actions">
        <button class="close-button" (click)="dismissModal()">
          <img src="./assets/images/close.svg">
        </button>
      </div>
    </div>

    <div class="side-panel-content">
      <div class="group-editor-container">
        <div class="group-editor">
          <div class="page-edit-form">
            <form [formGroup]="datasetForm">
              <div class="editor-row">
                <div class="input-group horizontal">
                  <label for="datasetName">Dataset Name</label>
                  <div class="input-wrapper">
                    <input type="text" class="form-control" id="datasetName" formControlName="name"
                      [disabled]="!isUserHasWriteAccess" placeholder="Dataset Name">
                  </div>
                </div>
              </div>

              <div class="editor-row">
                <div class="input-group horizontal">
                  <label for="fileUpload">Select file</label>
                  <div class="file-upload-section">
                    <!-- <div class="file-instructions">
                      Select a file (*.csv, *.xlsx). <a href="#" class="sample-file-link">Sample file here</a>
                    </div> -->
                    <div class="file-upload-controls">
                      <input id="fileUpload" type="file" accept=".csv,.xlsx" (change)="onFileSelected($event)"
                        [disabled]="!isUserHasWriteAccess" style="display: none;">
                      <div class="file-input-container">
                        <button type="button" class="choose-file-btn" [disabled]="!isUserHasWriteAccess" (click)="triggerFileInput()">Choose File</button>
                        <span class="file-name-display">{{ selectedFileName? 'File selected' : 'No file chosen' }}</span>
                      </div>
                      <button type="button" class="add-file-btn" (click)="uploadFile()"
                        [disabled]="!selectedFile || !isUserHasWriteAccess">Upload</button>
                    </div>
                    <div class="file-upload-instructions" *ngIf="selectedFileName">
                      <span class="file-name" data-title="{{selectedFileName}}">{{selectedFileName}}</span>
                    </div>
                    <div class="file-upload-instructions" *ngIf="!selectedFileName">Select a file (*.csv, *.xlsx).</div>
                  </div>
                </div>
              </div>

              <div class="editor-row">
                <div class="input-group horizontal">
                  <label>Display Field</label>
                  <div class="select-wrapper custom-select-wrapper">
                    <select class="form-select custom-select" [disabled]="!isUserHasWriteAccess" formControlName="displayField">
                      <option value="">Select</option>
                      <option *ngFor="let h of datasetHeaders" [value]="h">{{ h }}</option>
                    </select>
                    <img src="./assets/images/new-arrow.svg" class="custom-arrow" />
                  </div>
                </div>
              </div>

              <div class="editor-row">
                <div class="input-group horizontal">
                  <label>Value Field</label>
                  <div class="select-wrapper custom-select-wrapper">
                    <select class="form-select custom-select" [disabled]="!isUserHasWriteAccess" formControlName="valueField">
                      <option value="">Select</option>
                      <option *ngFor="let h of datasetHeaders" [value]="h">{{ h }}</option>
                    </select>
                    <img src="./assets/images/new-arrow.svg" class="custom-arrow" />
                  </div>
                </div>
              </div>

              <div class="editor-row">
                <div class="input-group horizontal">
                  <label>Parent Value Field</label>
                  <div class="select-wrapper custom-select-wrapper">
                    <select class="form-select custom-select" [disabled]="!isUserHasWriteAccess" formControlName="parentValueField">
                      <option value="">Select</option>
                      <option *ngFor="let h of datasetHeaders" [value]="h">{{ h }}</option>
                    </select>
                    <img src="./assets/images/new-arrow.svg" class="custom-arrow" />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="side-panel-footer">
      <button class="btn-cancel" (click)="dismissModal()">Cancel</button>
      <!-- <button class="btn-save" (click)="saveDataset()" [disabled]="datasetForm.invalid">Save</button> -->
      <button class="btn-save" (click)="uploadDataset()" [disabled]="datasetForm.invalid || !isUserHasWriteAccess">Save</button>
    </div>
  </div>
</div>